module.exports = __webpack_public_path__ + "img/qq.6d73bdca.png";